import React, {useState, useContext} from "react";
import Box from "@mui/material/Box";
import {makeStyles} from "@mui/styles"
import Button from "@mui/material/Button";
import {LoadingContext} from "@hoc/loading";
import {ErrorMessageContext} from "@hoc/errorMessage";
import {renderForm, updateInfo} from "@components/Form/renderForm";
import {add, addReferral} from '@api/db';
import {validation} from "@services/validation";
import Container from "@mui/material/Container";
import Grid from '@mui/material/Grid';
import Typography from "@mui/material/Typography";
import {red} from '@mui/material/colors';
import {styled} from '@mui/material/styles';
import {Activate} from '@components/Activate';
import 'react-phone-number-input/style.css'
import {ReferralSuccessMsg} from "../ReferralSuccessMsg";

const ColorButton = styled(Button)(({theme}) => ({
    fontSize: 32,
    backgroundColor: red[500],
    '&:hover': {
        backgroundColor: red[700],
    },
}));

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    submitBlock: {
        textAlign: 'center'
    },
    register: {
        justifyContent: 'center',
        minHeight: '200px',
    }
});

export const ReferralForm = () => {
        const classes = useStyles();
        const {loading, setLoading} = useContext(LoadingContext);
        const {errorMessage, setErrorMessage} = useContext(ErrorMessageContext);
        const [register, setRegister] = useState(false);
        const [form, setForm] = useState({});
        let search = window.location.search;
        let params = new URLSearchParams(search);
        const exportcsv = params.get('exportcsv');

        const onCallback = (e) => {
            updateOnCallback(e, columnData);
        }

        const updateOnCallback = (e, data) => {
            data.forEach((column) => {
                column.data.forEach((column) => {
                    if (column.name === e.target.name) {
                        let value = e.target.value;
                        if (column.type === 'select' || column.type === 'checkbox') {
                            if (!column.value.includes(value)) {
                                column.value.push(value);
                                value = column.value;
                            }
                        }
                        column.value = value;
                        column.error = '';
                    }
                })
                column.setFunc([...column.data]);
            })
        }

        const detailsData = [{
            name: 'first_name',
            headerName: 'First name',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'last_name',
            headerName: 'Last name',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'email',
            headerName: 'Email',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'phone',
            headerName: 'Phone Number',
            inputProps: {required: true},
            type: 'phone',
            value: '',
            onCallback: onCallback,
        }];

        const recomendationData = [{
            name: 'reffered_first_name',
            headerName: 'First name',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'reffered_last_name',
            headerName: 'Last name',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'reffered_email',
            headerName: 'Email',
            inputProps: {required: true},
            type: 'string',
            value: '',
            onCallback: onCallback,
        }, {
            name: 'reffered_phone',
            headerName: 'Phone Number',
            inputProps: {required: true},
            type: 'phone',
            value: '',
            onCallback: onCallback,
        }];


        const columnsData = [{
            name: 'slider',
            headerName: 'How far can you travel ?',
            value: 0,
            type: 'slider',
            onCallback: onCallback,
        }, {
            name: 'website',
            headerName: 'Please provide a link to examples of your work or website',
            value: '',
            type: 'string',
            onCallback: onCallback,
        }, {
            name: 'drone',
            headerName: 'Do you offer drone services?',
            value: '',
            defaultValue: '',
            items: [
                'Yes',
                'No',
            ],
            type: 'enum',
            onCallback: onCallback,
        }];
        // const [columns, setColumns] = useState(columnsData);
        const [columnsDetails, setColumnsDetails] = useState(detailsData);
        const [columnsRecomendation, setRecomendationData] = useState(recomendationData);
        const columnData = [
            {data: columnsDetails, setFunc: setColumnsDetails},
            {data: columnsRecomendation, setFunc: setRecomendationData},
        ]

        const handleSubmit = async (event) => {
            event.preventDefault();

            setLoading(true);
            setErrorMessage(null);

            try {
                const data = new FormData(event.target);
                let obj = updateInfo([...columnsDetails, ...columnsRecomendation], data);
                setForm(obj);
                obj.type = 'referral_form';
                const docRef = await addReferral(obj);
                setRegister(true);
            } catch (e) {
                validateData(e, columnData);
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const validateData = (e, data) => {
            data.forEach((column) => {
                validation(e, column.data, (columnUpdate) => {
                    return column.setFunc([...columnUpdate]);
                })
            })
        }

        const columnsEl = [{
            label: 'Your details',
            data: columnsDetails,
        }, {
            label: 'Who are you recommending?',
            data: columnsRecomendation,
        }]

        if (register) {
            window.scrollTo(0, 0)
            return <ReferralSuccessMsg form={form}/>
        }

        return (
            <Container maxWidth={'md'}>
                <Grid component="form"
                      container
                      justifyContent="start"
                      alignItems="center"
                      spacing={3}
                      onSubmit={handleSubmit}>
                    {columnsEl.map((column, ind) => (
                        <>
                            <Grid xs={12} key={ind} item>
                                <Typography variant="h4" gutterBottom>{column.label}</Typography>
                                <hr/>
                            </Grid>
                            {
                                column.data.map((data, key) => (
                                    renderForm(data, key)
                                ))
                            }
                        </>
                    ))}
                    <Grid item
                          style={{textAling: 'left'}}
                          xs={12}
                    >
                        <Typography variant="caption">*Mandatory</Typography>
                    </Grid>
                    <Grid item
                          className={classes.submitBlock}
                          xs={12}
                    >
                        <ColorButton
                            type="submit"
                            variant="contained"
                        >
                            submit
                        </ColorButton>
                    </Grid>
                </Grid>
            </Container>
        );
    }
;